/* eslint-disable array-callback-return, eqeqeq */
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";
import MOV from "./body_movement";
import Y_DIST from "./chest_displacement";
import SLP_STGS from "./sleep_stages";
import sleep_stages_probablity from "./sleep_stages_probablity";
import HR from "./heart_rate";
import HRV from "./heart_rate_variability";
import BR from "./breathing_rate";
import BRV from "./breathing_rate_variability";
import SPO2 from "./spo2";
import PR from "./pulse_rate";
import I from "./i_kpi";
import Q from "./q_kpi";
import IQ from "./iq_kpi";
import SA from "./sa_kpi";
import TB from "./tb_kpi";
import bp from "./bp_kpi";
import blood_sugar from "./bs_kpi";
import body_temp from "./bt_kpi";
import NC_PSG from "./nasal_cannula";
import THRX_PSG from "./thorax";
import ABD_PSG from "./abdomen";
import SPO2_PSG from "./spo2_psg";
import ls from "local-storage";

import icon_annotation_system from "assets/images/icon-graph-bulb.png";
import icon_annotation_system_edit from "assets/images/icon-graph-bulb-yellow.png";
import icon_annotation_user from "assets/images/icon-graph-user.png";

dayjs.extend(utc);
dayjs.extend(tz);

window.moment = dayjs;

var max, min;
const options = {
  MOV,
  Y_DIST,
  SLP_STGS,
  sleep_stages_probablity,
  HR,
  HRV,
  BR,
  BRV,
  SPO2,
  PR,
  I,
  Q,
  IQ,
  SA,
  TB,
  bp,
  blood_sugar,
  body_temp,
  NC_PSG,
  THRX_PSG,
  ABD_PSG,
  SPO2_PSG,
};

export const get_chart_options = ({
  kpi_id,
  analytics,
  recording_meta,
  sqbAnalytics,
  syncExtremes,
  height,
  zoom_type,
  set_annotate,
  set_annotate_range,
  mixed_annotations,
  annotation_flags,
  toggleGraphAnnotation,
  annotation_colours,
  customTimeRange,
  showEditAnnotationPopup,
  setCustomTimeRange,
  show_artifects_flag,
  show_plotbands,
  vital_parameters,
  custom_chart_type,
}) => {
  const { dataset, ts } = analytics;
  let xAxis;
  if (kpi_id === "IQ") {
    let i_min, i_max, q_min, q_max;
    try {
      i_min = Number(analytics.I.ts[0]) * 1000;
      i_max = Number(analytics.I.ts[analytics.I.ts.length - 1]) * 1000;
      q_min = Number(analytics.Q.ts[0]) * 1000;
      q_max = Number(analytics.Q.ts[analytics.Q.ts.length - 1]) * 1000;
    } catch (error) {
      console.log("ERROR MIN AND MAX  ", error);
    }
    xAxis = {
      min: i_min < q_min ? i_min : q_min,
      max: i_max > q_max ? i_max : q_max,
    };
  } else {
    xAxis = {
      min: ls.get("zoomMin") || Number(ts[0]) * 1000,
      max: ls.get("zoomMax") || Number(ts[ts.length - 1]) * 1000,
    };
  }

  if (mixed_annotations && mixed_annotations.length > 0) {
    let ac = "";
    xAxis.plotBands = mixed_annotations.map((a) => {
      ac = annotation_colours.find(
        (ac) => ac.value === a.color_code.toUpperCase()
      );
      let label = a.label;
      if (a.label.length > 10) {
        label = a.label.substring(0, 20) + "...";
      }

      let aTypeIconSrc = icon_annotation_user;
      if (a.type === "system" || a.type === "desaturation") {
        aTypeIconSrc = icon_annotation_system;
      } else if (a.type === "system-edit") {
        aTypeIconSrc = icon_annotation_system_edit;
      }
      let getTimezoneOffset = dayjs(a.start_date)
        .tz(recording_meta.timezone)
        .utcOffset();

      let timezone_offset = Math.abs(getTimezoneOffset * 60);
      let start_time =
        getTimezoneOffset < 0
          ? dayjs.utc(a.start_date).unix() + timezone_offset
          : dayjs.utc(a.start_date).unix() - timezone_offset;
      let end_time =
        getTimezoneOffset < 0
          ? dayjs.utc(a.end_date).unix() + timezone_offset
          : dayjs.utc(a.end_date).unix() - timezone_offset;

      let annotation = {
        from: (dayjs.utc(start_time).valueOf() * 1000).toString(),
        to: (dayjs.utc(end_time).valueOf() * 1000).toString(),
        label: {
          text: `
                        <img
                            src=${aTypeIconSrc}
                            alt=''
                            style='cursor: pointer'
                            onmousemove="document.getElementById('${"a-i-t-" +
                              kpi_id +
                              "-" +
                              a.annotation_map_id}').style.display='block';"
                            onmouseout="document.getElementById('${"a-i-t-" +
                              kpi_id +
                              "-" +
                              a.annotation_map_id}').style.display='none';"
                        />
                        <div id=${"a-i-t-" +
                          kpi_id +
                          "-" +
                          a.annotation_map_id} class='a-icon-tooltip'>${label}</div>
                    `,
          useHTML: true,
          align: "left",
          y: 11,
        },
        color: (ac && ac.light) || "rgb(255, 234, 173,0.3)",
        zIndex: 5,
        annotation_map_id: a.annotation_map_id,
        annotation_type: a.type,
        events: {
          click: function() {
            showEditAnnotationPopup(this.options.annotation_map_id);
          },
          mousemove: function(e) {
            let color = (ac && ac.medium) || "rgb(255, 234, 173,0.5)";
            this.svgElem.attr("fill", color).css({ cursor: "pointer" });

            let chart = this.axis.chart;
            if (
              chart &&
              chart.customLabel &&
              Object.keys(chart.customLabel).length > 0
            ) {
              chart.customLabel.destroy();
            }

            if (label.length > 0) {
              chart.customLabel = chart.renderer
                .label(
                  label,
                  e.offsetX - label.length * 5,
                  e.offsetY + 20,
                  e.offsetX - label.length * 5,
                  e.offsetY + 20,
                  false,
                  true
                )
                .attr({
                  fill: "#053D6E",
                  padding: 8,
                  r: 5,
                  zIndex: 11,
                })
                .css({
                  color: "#FFFFFF",
                  opacity: 1,
                })
                .add();
            }
          },
          mouseout: function() {
            this.svgElem.attr("fill", this.options.color);

            let chart = this.axis.chart;
            if (
              chart &&
              chart.customLabel &&
              Object.keys(chart.customLabel).length > 0
            ) {
              chart.customLabel.destroy();
            }
          },
        },
      };

      return annotation;
    });
  }

  let opt, min_range, max_range;
  if (sqbAnalytics) {
    const { ts } = sqbAnalytics;
    min_range = Number(ts[0]) * 1000;
    max_range = Number(ts[ts.length - 1]) * 1000;
  }
  if (kpi_id === "IQ") {
    const data = {
      I: analytics.I.dataset.map((d, i) => {
        const t = Number(analytics.I.ts[i] * 1000);
        return [t, d === -1 ? null : d === -2 ? null : Number(d)];
      }),
      Q: analytics.Q.dataset.map((d, i) => {
        const t = Number(analytics.I.ts[i] * 1000);
        return [t, d === -1 ? null : d === -2 ? null : Number(d)];
      }),
    };

    opt = options[kpi_id]({ data });
  } else if (kpi_id === "I" || kpi_id === "Q") {
    const data = dataset.map((d, i) => {
      const t = Number(ts[i]) * 1000;
      return [t, d === -1 ? null : d === -2 ? null : Number(d)];
    });
    opt = options[kpi_id]({ data, sample: "sample" });
  } else if (kpi_id === "SPO2" || kpi_id === "PR") {
    const data = dataset.map((d, i) => {
      const t = Number(ts[i]) * 1000;
      return [t, d <= 0 ? null : d === null ? null : Number(d)];
    });
    opt = options[kpi_id]({ data });
  } else if (kpi_id === "BR" || kpi_id === "HR") {
    const data = dataset.map((d, i) => {
      const t = Number(ts[i]) * 1000;
      return [t, d === -2 ? null : d === null ? null : Number(d)];
    });
    opt = options[kpi_id]({ data });
  } else if (kpi_id === "bp") {
    let data = [];
    for (let i = 0; i < dataset.length; i++) {
      const t = Number(ts[i]) * 1000;
      const dia = dataset[i] === null ? null : Number(dataset[i]);
      const sys =
        analytics.dataset_systolic[i] === null
          ? null
          : Number(analytics.dataset_systolic[i]);
      data.push([t, dia, dia, NaN, dia, sys]);
    }
    opt = options[kpi_id]({ data });
  } else {
    const data = dataset.map((d, i) => {
      const t = Number(ts[i]) * 1000;
      if (kpi_id === "SLP_STGS") {
        switch (d) {
          case 0 || null:
            return [t, null];
          case 1:
            return [t, 0];
          case 2 || 3:
            return [t, 1];
          case 4:
            return [t, 2];
          case 5:
            return [t, 3];
        }
      }

      if (kpi_id === "SA" || kpi_id === "TB") {
        if (d == null) {
          return [t, null];
        }
      }
      if (
        kpi_id === "NC_PSG" ||
        kpi_id === "THRX_PSG" ||
        kpi_id === "ABD_PSG" ||
        kpi_id === "SPO2_PSG"
      ) {
        if (d == null) {
          return [t, null];
        }
      }
      return [t, d === null ? null : Number(d)];
    });
    opt = options[kpi_id]({ data, sample: "sample" });
  }

  if (
    show_artifects_flag &&
    sqbAnalytics &&
    ["Y_DIST", "BR", "HR"].indexOf(kpi_id) > -1
  ) {
    let minVal = -0.4;
    let maxVal = 0.4;
    if (kpi_id !== "Y_DIST") {
      minVal = Number(Math.min.apply(null, analytics.dataset).toFixed(2));
      maxVal = Number(Math.max.apply(null, analytics.dataset).toFixed(2));
    }

    const sqbData = sqbAnalytics.dataset.map((d, i) => {
      const t = Number(sqbAnalytics.ts[i]) * 1000;
      let ds;
      if (kpi_id !== "Y_DIST") {
        ds = Math.ceil(minVal + (maxVal - minVal) * (d === 1 ? 0 : 1));
      } else {
        ds = minVal + (maxVal - minVal) * (d === 1 ? 0 : 1);
      }
      return [t, minVal, Number(ds)];
    });

    const sqbSeries = {
      type: "arearange",
      step: true,
      name: "Signal Quality Binary",
      showInLegend: false,
      fillColor: "rgba(154, 162, 233, 0.20)",
      data: sqbData,
    };

    opt.series[0] = { ...opt.series[0], type: opt.chart.type };
    opt.series[1] = sqbSeries;

    opt.yAxis = [
      opt.yAxis,
      {
        title: {
          enabled: false,
        },
        labels: {
          enabled: false,
        },
      },
    ];
  }

  let tickAmount = 3;
  if (["MOV", "SA", "TB"].indexOf(kpi_id) > -1) {
    tickAmount = 2;
  }
  if (["BR", "HR", "SLP_STGS"].indexOf(kpi_id) > -1 && show_artifects_flag) {
    tickAmount = 4;
  }
  if (["SLP_STGS"].indexOf(kpi_id) > -1) {
    tickAmount = 4;
  }
  if (["Y_DIST"].indexOf(kpi_id) > -1) {
    if (!show_artifects_flag) {
      opt.yAxis.min = -0.04;
    } else {
      opt.yAxis.min = -0.36;
    }
  }
  let moderateMin,
    moderateMax,
    severeMin,
    severeMax,
    moderateMinF,
    moderateMaxF,
    moderateMinS,
    moderateMaxS,
    severeMinF,
    severeMaxF,
    severeMinS,
    severeMaxS;
  if (
    ["BR"].indexOf(kpi_id) > -1 &&
    vital_parameters !== undefined &&
    vital_parameters.br
  ) {
    moderateMinF = Number(vital_parameters.br.modFromF);
    moderateMaxF = Number(vital_parameters.br.modToF);
    moderateMinS = Number(vital_parameters.br.modFromS);
    moderateMaxS = Number(vital_parameters.br.modToS);
    severeMinF = Number(vital_parameters.br.sevFromF);
    severeMaxF = Number(vital_parameters.br.sevToF);
    severeMinS = Number(vital_parameters.br.sevFromS);
    severeMaxS = Number(vital_parameters.br.sevToS);
  } else if (
    ["PR"].indexOf(kpi_id) > -1 &&
    vital_parameters !== undefined &&
    vital_parameters.pr
  ) {
    moderateMinF = Number(vital_parameters.pr.modFromF);
    moderateMaxF = Number(vital_parameters.pr.modToF);
    moderateMinS = Number(vital_parameters.pr.modFromS);
    moderateMaxS = Number(vital_parameters.pr.modToS);
    severeMinF = Number(vital_parameters.pr.sevFromF);
    severeMaxF = Number(vital_parameters.pr.sevToF);
    severeMinS = Number(vital_parameters.pr.sevFromS);
    severeMaxS = Number(vital_parameters.pr.sevToS);
  } else if (
    ["SPO2"].indexOf(kpi_id) > -1 &&
    vital_parameters !== undefined &&
    vital_parameters.spo2
  ) {
    console.log("vital_parameters: ", vital_parameters, " kpi_id: ", kpi_id);
    moderateMin = Number(vital_parameters.spo2.modFrom);
    moderateMax = Number(vital_parameters.spo2.modTo);
    severeMin = Number(vital_parameters.spo2.sevFrom);
    severeMax = Number(vital_parameters.spo2.sevTo);
  }
  opt = {
    ...opt,
    title: {
      ...opt.title,
      id: kpi_id,
    },
    time: {
      // useUTC: true,
      timezone: recording_meta ? recording_meta.timezone : "",
    },
    xAxis: {
      ...opt.xAxis,
      ...xAxis,
      type: "datetime",
      scrollbar: {
        enabled: false,
      },
      startOnTick: false,
      endOnTick: false,
      min: min_range,
      max: max_range,
      showLastLabel: true,
      events: {
        setExtremes: syncExtremes,
      },
    },
    yAxis: {
      ...opt.yAxis,
      opposite: false,
      tickAmount: tickAmount,
      startOnTick: false,
      endOnTick: false,
      showLastLabel: true,
      labels: {
        ...opt.yAxis.labels,
        y: 5,
      },
      plotBands: [
        {
          from: moderateMin ? moderateMin : moderateMinF,
          to: moderateMax ? moderateMax : moderateMaxF,
          color: show_plotbands ? "#fcffbd" : "white",
          label: {
            text: "",
          },
        },
        {
          from: severeMin ? severeMin : severeMinF,
          to: severeMax ? severeMax : severeMaxF,
          color: show_plotbands ? "#ffbdbd" : "white",
          label: {
            text: "",
          },
        },
        {
          from: moderateMinS ? moderateMinS : "",
          to: moderateMaxS ? moderateMaxS : "",
          color: show_plotbands ? "#fcffbd" : "white",
          label: {
            text: "",
          },
        },
        {
          from: severeMinS ? severeMinS : "",
          to: severeMaxS ? severeMaxS : "",
          color: show_plotbands ? "#ffbdbd" : "white",
          label: {
            text: "",
          },
        },
      ],
    },
    chart: {
      ...opt.chart,
      zoomType: zoom_type,
      type: !custom_chart_type
        ? "line"
        : opt.chart.type
          ? opt.chart.type
          : "line",
      selection: true,
      height,
      events: {
        click: function(e) {
          const mins = 180000; //3mins
          const sec = 30000; //30secs
          document.getElementById("charts").ondblclick = () => {
            let range = e.xAxis[0].axis.max - e.xAxis[0].axis.min;
            if (range === mins) {
              setCustomTimeRange([e.xAxis[0].value + sec, e.xAxis[0].value]);
            } else {
              setCustomTimeRange([e.xAxis[0].value + mins, e.xAxis[0].value]);
            }
          };
        },
        redraw: function() {},
        load: async function(e) {
          if (
            (customTimeRange && customTimeRange.length === 2) ||
            (annotation_flags && Object.values(annotation_flags).length > 0)
          ) {
            let axis = e.target.xAxis[0];
            let updatedMin = (await ls.get("zoomMin")) || min;
            let updatedMax = (await ls.get("zoomMax")) || max;
            axis.setExtremes(updatedMin, updatedMax);
          }

          let containerHeight = window.innerHeight - 200;
          let chartElements = document.querySelectorAll(".chart-block");
          let expChartElements = document.querySelectorAll(
            ".chart-block.expanded"
          );
          let chartHeight;

          if (expChartElements && expChartElements.length) {
            if (expChartElements.length === 1) {
              chartHeight = containerHeight - 10;
            } else if (expChartElements.length === 2) {
              chartHeight = (containerHeight - 20) / 2;
            } else if (expChartElements.length === 3) {
              chartHeight = (containerHeight - 30) / 3;
            } else if (
              expChartElements.length === 4 ||
              expChartElements.length >= 4
            ) {
              chartHeight = (containerHeight - 40) / 4;
            }
          } else {
            if (chartElements.length > 2) {
              chartHeight = (containerHeight - 20) / 2;
            } else {
              chartHeight = containerHeight - 10;
            }
          }

          for (let i = 0; i < chartElements.length; i++) {
            chartElements[i].style.height = chartHeight + "px";
          }

          if (e.target) {
            e.target.reflow();
          }
        },
        selection: function(event) {
          //if (zoom_type !== 'x') return;
          max = event.target.xAxis[0].max;
          min = event.target.xAxis[0].min;
          if (event.xAxis) {
            set_annotate_range([
              dayjs
                .utc(Math.round(event.xAxis[0].min))
                .tz(recording_meta.timezone)
                .format("YYYY-MM-DD HH:mm:ss"),
              dayjs
                .utc(Math.round(event.xAxis[0].max))
                .tz(recording_meta.timezone)
                .format("YYYY-MM-DD HH:mm:ss"),
            ]);
            if (annotation_flags[kpi_id]) {
              set_annotate(true);
              return false;
            }
            if (event.originalEvent && event.originalEvent.ctrlKey === true) {
              toggleGraphAnnotation(kpi_id);
              set_annotate(true);
              return false;
            }

            setCustomTimeRange([event.xAxis[0].max, event.xAxis[0].min]);
          }
        },
      },
      resetZoomButton: {
        theme: {
          display: "none",
        },
      },
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    tooltip: ["bp", "blood_sugar", "body_temp"].includes(kpi_id)
      ? opt.tooltip
      : {
          ...opt.tooltip,
          formatter: function() {
            let {
              dataMax = "-- : --",
              dataMin = "-- : --",
            } = this.points[0].series;

            const y = Math.floor(this.y * 100) / 100;
            const x = dayjs
              .utc(this.x)
              .tz(recording_meta.timezone)
              .format("hh:mm A, DD MMM");

            if (typeof dataMax === "number") {
              dataMax = Math.floor(dataMax * 100) / 100;
            }
            if (typeof dataMin === "number") {
              dataMin = Math.floor(dataMin * 100) / 100;
            }
            return `<b>Value</b>: ${y} at ${x}`;
          },
        },
    plotOptions: {
      ...opt.plotOptions,
      series: {
        events: {
          click: function(e) {
            const mins = 180000; //3mins
            const sec = 30000; //30secs
            document.getElementById("charts").ondblclick = () => {
              let range = e.point.series.xAxis.max - e.point.series.xAxis.min;
              if (range === mins) {
                setCustomTimeRange([e.point.x + sec, e.point.x]);
              } else {
                setCustomTimeRange([e.point.x + mins, e.point.x]);
              }
            };
          },
        },
      },
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 800,
          },
          chartOptions: {
            rangeSelector: {
              inputEnabled: false,
            },
          },
        },
      ],
    },
    rangeSelector: {
      enabled: false,
    },
    scrollbar: {
      enabled: false,
    },
  };
  if (kpi_id === "SA" || kpi_id === "TB" || kpi_id === "MOV") {
    if (opt.series[0].data.length < 1000) {
      opt.series[0] = {
        ...opt.series[0],
        lineWidth: 1,
        type: "line",
      };
    }
  }

  return opt;
};

export default options;
